// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__KV4do","toggle":"style_toggle__zk1dD","toggle_btn":"style_toggle_btn__NNDN9"};